import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { from, Observable, switchMap, take } from 'rxjs';
import { Injectable, Injector } from '@angular/core';
import { AuthService } from '../../auth/auth.service';
import { CompanyService } from '../../companies/company.service';

@Injectable()
export class APIInterceptor implements HttpInterceptor {
  constructor(
    private authService: AuthService,
    private injector: Injector,
  ) {}

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return from(this.authService.getValidToken()).pipe(
      take(1),
      switchMap((token) => {
        const selectedCompany = this.injector.get<CompanyService>(CompanyService).selectedCompany() ?? 'aoa-br';
        const newReq = req.clone({
          headers: req.headers.set('x-billy-api-auth', token ?? '').set('selected-company', selectedCompany),
        });
        return next.handle(newReq);
      }),
    );
  }
}
